import {colors} from 'helpers/style'
import _ from 'lodash'
import moment from 'moment'
import {useEffect} from 'react'
import {useState} from 'react'
import ApexCharts from 'react-apexcharts'

function formatTimestamp(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
  return moment.utc(timestamp).format(format)
}
function selectedTimeRange(statusRecords) {
  const format = 'YYYYMMDDTHHmmss'
  const beginTime = formatTimestamp(statusRecords[0].timestamp, format)
  const endTime = formatTimestamp(statusRecords.slice(-1).pop().timestamp, format)
  if (beginTime.split('T')[0] == endTime.split('T')[0]) {
    return `${beginTime}-${endTime.split('T')[1]}`
  } else {
    return `${beginTime}-${endTime}`
  }
}
const StatusRecordChart = ({gatewaysview, statusRecords, setStatusRecord, height = 300}) => {
  const [data, setData] = useState(null)

  const handleClickOnDataPoint = index => {
    if (index >= 0) {
      setStatusRecord(statusRecords[index])
    }
  }

  const setup = () => {
    const extractStatusRecords = (statusRecords, accessor, transformer = val => val) =>
      _.map(statusRecords, temp => {
        const value = accessor(temp)
        return value !== undefined ? transformer(value) : null
      })

    const speed = extractStatusRecords(
      statusRecords,
      status => status.speed,
      val => val * 1
    )
    const voltage = extractStatusRecords(statusRecords, status => status.voltage)
    const current = extractStatusRecords(statusRecords, status => status.current)

    const categories = _.map(statusRecords, status => moment(status.timestamp).local().toISOString())

    const allStatusRecords = [...speed, ...voltage, ...current].filter(Boolean)

    const [yaxisMin, yaxisMax] = [
      Math.floor((Math.min(...allStatusRecords) - 5) / 5) * 5,
      Math.ceil((Math.max(...allStatusRecords) + 5) / 5) * 5
    ]
    const pixelPerTick = 25 // Ideal min space per tick in pixels
    const maxTicks = Math.floor(height / pixelPerTick) // Adjust based on chart height
    const range = yaxisMax - yaxisMin

    // Find the largest tickAmount that is a multiple of 5 and ≤ maxTicks
    let tickAmount = 5
    for (let i = maxTicks; i >= 5; i--) {
      if (i % 5 === 0) {
        tickAmount = i
        break
      }
    }

    // Snap the interval to a multiple of 5 as well
    const interval = Math.ceil(range / tickAmount / 5) * 5
    const adjustedTickAmount = Math.ceil(range / interval)
    const adjustedyaxisMax = yaxisMin + adjustedTickAmount * interval
    const series = {
      data: [
        {
          name: 'Speed',
          data: speed
        },
        {
          name: 'Voltage',
          data: voltage
        },
        {
          name: 'Current',
          data: current
        }
      ],
      colors: [colors.rgs.speed, colors.rgs.voltage, colors.rgs.current],
      fillColors: ['transparent', 'transparent', 'transparent']
    }

    setData({
      series: series.data,
      options: {
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'left',
          floating: false,
          offsetY: 0,
          markers: {
            width: 12,
            height: 12,
            radius: 2
          },
          labels: {
            useSeriesColors: false
          }
        },
        chart: {
          type: 'area',
          events: {
            click(event, chartContext, config) {
              handleClickOnDataPoint(config.dataPointIndex)
            }
          },
          selection: {
            enabled: true
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: false,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true,
              customIcons: []
            },
            export: {
              csv: {
                filename: `${gatewaysview.g_name} ${selectedTimeRange(statusRecords)}`,
                headerCategory: 'Timestamp UTC',
                dateFormatter: formatTimestamp
              }
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        colors: series.colors,
        stroke: {
          curve: 'smooth',
          width: 4,
          dashArray: 4
        },
        fill: {
          type: 'solid',
          opacity: 0.3,
          colors: series.fillColors
        },
        xaxis: {
          type: 'datetime',
          categories: categories,
          labels: {
            datetimeUTC: false,
            datetimeFormatter: {
              year: 'yyyy',
              month: "MMM 'yy",
              day: 'MM/dd',
              hour: 'hh:mmTT'
            }
          },
          show: true
        },
        yaxis: {
          forceNiceScale: false,
          show: true,
          tickAmount: adjustedTickAmount,
          min: yaxisMin,
          max: adjustedyaxisMax,
          labels: {
            formatter: value => {
              return Math.round(value) // No decimal places for y-axis labels
            }
          }
        },
        tooltip: {
          x: {
            format: 'yyyy/MM/dd HH:mm'
          },
          y: {
            formatter: value => {
              return value.toFixed(2) // 2 decimal places in tooltip
            }
          }
        },
        annotations: {
          yaxis: []
        }
      }
    })
  }

  useEffect(() => {
    if (statusRecords) setup()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusRecords])

  if (data) {
    return (
      <div id="statusRecord-chart" style={{height: `${height}px`}}>
        <ApexCharts options={data.options} series={data.series} type="area" height={height} />
      </div>
    )
  } else {
    return <div id="statusRecord-chart" style={{height: `${height}px`}}></div>
  }
}

export default StatusRecordChart
